import { useState } from 'react';

const getType = (type) => {
  if (!type) return type;
  return type.toLowerCase() === 'text' ? 'string' : type;
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ''; // Invalid date

  return new Intl.DateTimeFormat('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'UTC', // Specify UTC timezone
  }).format(date);
};

const formatDateRange = (value) => {
  const { from, to } = value || {};
  const formattedFromDate = formatDate(from);
  const formattedToDate = formatDate(to);

  return !formattedFromDate && !formattedToDate
    ? ''
    : `${formattedFromDate},${formattedToDate}`;
};

const isEmptyValue = (value, type) => {
  return (
    !value ||
    value === '' ||
    (type === 'dateRange' &&
      (value === ',' || value === ',,' || value.split(',').every((d) => !d)))
  );
};

const updateSearchArray = (searchArr, searchObj, createSearchArray) => {
  const index = searchArr.findIndex((filter) => filter.field === searchObj.field);
  if (index !== -1) {
    // Update existing item
    const updatedArray = [...searchArr];
    updatedArray[index] = searchObj;
    createSearchArray(updatedArray);
  } else {
    // Add new item
    createSearchArray([...searchArr, searchObj]);
  }
};

export const useDataTable = () => {
  const [sortingObj, setSortingObj] = useState({});
  const [searchArr, createSearchArray] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);

  const setSearchArry = (() => {
    let debounceTimer;

    return (searchObj) => {
      // Convert type if it's a text field
      if (searchObj.type) {
        searchObj.type = getType(searchObj.type);
      }

      // Handle date type
      if (searchObj.type === 'date') {
        const date = new Date(searchObj.value);
        searchObj.value = isNaN(date.getTime())
          ? '' // Invalid date
          : formatDate(searchObj.value);
      }

      // Handle dateRange type
      if (searchObj.type === 'dateRange') {
        searchObj.value = formatDateRange(searchObj.value);
      }

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (isEmptyValue(searchObj.value, searchObj.type)) {
          // Remove items with empty values
          const filteredArray = searchArr.filter(
            (filter) => filter.field !== searchObj.field
          );
          createSearchArray(filteredArray);
        } else {
          // Update existing or add new item
          updateSearchArray(searchArr, searchObj, createSearchArray);
        }
      }, 1000);

      // Reset page to 1 when filtering
      setPageIndex(0);
    };
  })();

  const resetSearchArr = () => {
    createSearchArray([]);
  };

  const handleResetAll = () => {
    createSearchArray([]);
    setSortingObj({});
    setPageIndex(0);
  };

  return {
    searchArr,
    sortingObj,
    pageIndex,
    setSortingObj,
    setSearchArry,
    setPageIndex,
    resetSearchArr,
    handleResetAll,
  };
};